import React from "react";
import { IconChevronRight } from "@tabler/icons-react";
import { IconArrowNarrowRight } from "@tabler/icons-react";
import { IconClockFilled } from "@tabler/icons-react";

const Technologies = () => {
  return (
    <div>
      <section className="mt-[71px] bg-[url(../images/banner-bg.png)] bg-cover bg-no-repeat md:mt-[87px] xl:mt-0">
        <div className="bg-primary bg-opacity-40 py-[52px]">
          <div className="container text-n8">
            <h3 className="h3 mb-2.5">Technologies</h3>
            <ul className="flex flex-wrap items-center gap-2">
              <li>
                <a href="/" className="home-link">
                  Home
                </a>
              </li>
              <li className="flex items-center">
                <IconChevronRight size={24} />
              </li>
              <li>
                <a href="/technologies" className="home-link">
                  Technologies
                </a>
              </li>
            </ul>
          </div>
        </div>
      </section>
      <section className="section relative bg-light">
        <img
          src="assets/images/element-2.png"
          className="animate-rotate absolute left-0 top-10 hidden origin-center xxl:block"
          alt=""
        />
        <div className="container">
          <div className="grid grid-cols-12 gap-6">
            <div className="col-span-12 lg:col-span-6 xxl:col-span-5"data-aos="fade-right">
              <div className="sticky top-20">
                <span className="h5 font-semibold text-primary">
                  Discover Our Company
                </span>
                <h3 className="h3 mb-4 mt-2">
                  We love providing superior IT services to businesses.
                </h3>
                <p className="mb-8 text-lg text-para">
                  Cognity offers a diverse variety of information
                  technology-related goods and services, such as web
                  development, digital marketing services, and mobile app
                  development.
                </p>

                <div className="mt-10 flex flex-wrap items-center gap-6 lg:mt-[60px]">
                  <a href="/about-us" className="btn-primary">
                    About us
                    <IconArrowNarrowRight size={24} />
                  </a>
                  <div className="flex shrink-0 items-center gap-4">
                    <div className="rounded-full border-2 border-n4 p-[14px]">
                      <span className="flex items-center justify-center rounded-full text-primary">
                        <IconClockFilled size={32} />
                      </span>
                    </div>
                    <div className="group-0 group">
                      <p className="sm-text text-black">Opening & Close Time</p>
                      <p className="text-lg font-semibold text-title">
                        8:00AM - 6:00PM
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="relative col-span-12 lg:col-span-6 xxl:col-start-7"data-aos="fade-left">
              <figure className="relative" data-cues="fadeIn">
                <img
                  src="assets/images/element-3.png"
                  alt="element"
                  className="animate-rotate absolute -top-20 right-10 hidden xxl:block xxxl:-right-32"
                />
                <img
                  src="assets/images/about-img-1.png"
                  alt="image"
                  className="relative z-[1] w-full"
                />
                <figcaption className="absolute right-0 top-0 z-[2] flex flex-col items-center bg-primary3 p-4 sm:p-6 lg:px-9 lg:py-[60px] xl:-right-4 xl:-top-14 xxxl:-right-14">
                  <span className="outline-text text-[10vw] font-semibold leading-tight">
                    21
                  </span>
                  <span className="text-lg text-n8 lg:text-[26px]">
                    Years Of Experience
                  </span>
                </figcaption>
              </figure>
            </div>
          </div>
        </div>
      </section>
      <section className="relative">
        <div
          className="relative bg-top bg-no-repeat spy120px"
          style={{ backgroundColor: "rgb(66 163 179 / 72%)" }}
        >
          <div className="relative z-[1] mx-auto max-w-[918px] text-center" data-aos="fade-right">
            <h5 className="h5 mb-5 text-white">Technologies We Work on</h5>
            <h3 className="h3 mb-5 text-n8 text-title">
              We Hold Expertise in the Following Technologies
            </h3>
            <p className="mx-auto mb-10 max-w-2xl text-n8 lg:mb-[60px]">
              We specify the elements to guarantee the quality of service (QoS)
              on networks with planned architecture and properly integrated
              services.
            </p>
          </div>

          <div className="container grid grid-cols-12 gap-4 lg:gap-6" data-aos="fade-left">
            <div className="col-span-12 sm:col-span-6 md:col-span-4 lg:col-span-3 xxl:col-span-2">
              <div className="flex items-center gap-4 rounded-lg bg-light px-2.5 py-5">
                <div className="flex h-[50px] w-[50px] items-center justify-center overflow-hidden rounded-lg bg-n8 p-2.5 shadow-lg">
                  <img
                    src="assets/images/brand-icon-1.png"
                    alt="Android"
                    className="w-full"
                  />
                </div>
                <p className="text-lg font-medium text-title">Android</p>
              </div>
            </div>
            <div className="col-span-12 sm:col-span-6 md:col-span-4 lg:col-span-3 xxl:col-span-2">
              <div className="flex items-center gap-4 rounded-lg bg-light px-2.5 py-5">
                <div className="flex h-[50px] w-[50px] items-center justify-center overflow-hidden rounded-lg bg-n8 p-2.5 shadow-lg">
                  <img
                    src="assets/images/brand-icon-2.png"
                    alt="Codeigniter"
                    className="w-full"
                  />
                </div>
                <p className="text-lg font-medium text-title">Codeigniter</p>
              </div>
            </div>
            <div className="col-span-12 sm:col-span-6 md:col-span-4 lg:col-span-3 xxl:col-span-2">
              <div className="flex items-center gap-4 rounded-lg bg-light px-2.5 py-5">
                <div className="flex h-[50px] w-[50px] items-center justify-center overflow-hidden rounded-lg bg-n8 p-2.5 shadow-lg">
                  <img
                    src="assets/images/brand-icon-3.png"
                    alt="Flutter"
                    className="w-full"
                  />
                </div>
                <p className="text-lg font-medium text-title">Flutter</p>
              </div>
            </div>
            <div className="col-span-12 sm:col-span-6 md:col-span-4 lg:col-span-3 xxl:col-span-2">
              <div className="flex items-center gap-4 rounded-lg bg-light px-2.5 py-5">
                <div className="flex h-[50px] w-[50px] items-center justify-center overflow-hidden rounded-lg bg-n8 p-2.5 shadow-lg">
                  <img
                    src="assets/images/brand-icon-4.png"
                    alt="Nodejs"
                    className="w-full"
                  />
                </div>
                <p className="text-lg font-medium text-title">Nodejs</p>
              </div>
            </div>
            <div className="col-span-12 sm:col-span-6 md:col-span-4 lg:col-span-3 xxl:col-span-2">
              <div className="flex items-center gap-4 rounded-lg bg-light px-2.5 py-5">
                <div className="flex h-[50px] w-[50px] items-center justify-center overflow-hidden rounded-lg bg-n8 p-2.5 shadow-lg">
                  <img
                    src="assets/images/brand-icon-5.png"
                    alt="Python"
                    className="w-full"
                  />
                </div>
                <p className="text-lg font-medium text-title">Python</p>
              </div>
            </div>
            <div className="col-span-12 sm:col-span-6 md:col-span-4 lg:col-span-3 xxl:col-span-2">
              <div className="flex items-center gap-4 rounded-lg bg-light px-2.5 py-5">
                <div className="flex h-[50px] w-[50px] items-center justify-center overflow-hidden rounded-lg bg-n8 p-2.5 shadow-lg">
                  <img
                    src="assets/images/brand-icon-6.png"
                    alt="React"
                    className="w-full"
                  />
                </div>
                <p className="text-lg font-medium text-title">React</p>
              </div>
            </div>
            <div className="col-span-12 sm:col-span-6 md:col-span-4 lg:col-span-3 xxl:col-span-2">
              <div className="flex items-center gap-4 rounded-lg bg-light px-2.5 py-5">
                <div className="flex h-[50px] w-[50px] items-center justify-center overflow-hidden rounded-lg bg-n8 p-2.5 shadow-lg">
                  <img
                    src="assets/images/brand-icon-7.png"
                    alt="Swift"
                    className="w-full"
                  />
                </div>
                <p className="text-lg font-medium text-title">Swift</p>
              </div>
            </div>
            <div className="col-span-12 sm:col-span-6 md:col-span-4 lg:col-span-3 xxl:col-span-2">
              <div className="flex items-center gap-4 rounded-lg bg-light px-2.5 py-5">
                <div className="flex h-[50px] w-[50px] items-center justify-center overflow-hidden rounded-lg bg-n8 p-2.5 shadow-lg">
                  <img
                    src="assets/images/brand-icon-8.png"
                    alt="Angular"
                    className="w-full"
                  />
                </div>
                <p className="text-lg font-medium text-title">Angular</p>
              </div>
            </div>
            <div className="col-span-12 sm:col-span-6 md:col-span-4 lg:col-span-3 xxl:col-span-2">
              <div className="flex items-center gap-4 rounded-lg bg-light px-2.5 py-5">
                <div className="flex h-[50px] w-[50px] items-center justify-center overflow-hidden rounded-lg bg-n8 p-2.5 shadow-lg">
                  <img
                    src="assets/images/brand-icon-9.png"
                    alt="C Sharp"
                    className="w-full"
                  />
                </div>
                <p className="text-lg font-medium text-title">C Sharp</p>
              </div>
            </div>
            <div className="col-span-12 sm:col-span-6 md:col-span-4 lg:col-span-3 xxl:col-span-2">
              <div className="flex items-center gap-4 rounded-lg bg-light px-2.5 py-5">
                <div className="flex h-[50px] w-[50px] items-center justify-center overflow-hidden rounded-lg bg-n8 p-2.5 shadow-lg">
                  <img
                    src="assets/images/brand-icon-10.png"
                    alt="Java"
                    className="w-full"
                  />
                </div>
                <p className="text-lg font-medium text-title">Java</p>
              </div>
            </div>
            <div className="col-span-12 sm:col-span-6 md:col-span-4 lg:col-span-3 xxl:col-span-2">
              <div className="flex items-center gap-4 rounded-lg bg-light px-2.5 py-5">
                <div className="flex h-[50px] w-[50px] items-center justify-center overflow-hidden rounded-lg bg-n8 p-2.5 shadow-lg">
                  <img
                    src="assets/images/brand-icon-11.png"
                    alt="Windows"
                    className="w-full"
                  />
                </div>
                <p className="text-lg font-medium text-title">Windows</p>
              </div>
            </div>
            <div className="col-span-12 sm:col-span-6 md:col-span-4 lg:col-span-3 xxl:col-span-2">
              <div className="flex items-center gap-4 rounded-lg bg-light px-2.5 py-5">
                <div className="flex h-[50px] w-[50px] items-center justify-center overflow-hidden rounded-lg bg-n8 p-2.5 shadow-lg">
                  <img
                    src="assets/images/brand-icon-12.png"
                    alt="Laravel"
                    className="w-full"
                  />
                </div>
                <p className="text-lg font-medium text-title">Laravel</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Technologies;
